import React from 'react';
import { LocaleService } from '@sm360/widget-commons-core-services';

import ProfileModal from 'login/components/Profile/ProfileModal.jsx';

import { ModalService, ProfileService, AnalyticsService } from '@sm360/widget-commons-general';
import AuthenticationService from 'login/services/AuthenticationService/AuthenticationService.js';
import MediaQuery from 'react-responsive';
import { PROFILE } from 'login/constants/modalNames.js';
import TAGS from 'login/constants/trackingTags';

import 'login/components/LoginMenu/LoginMenu.scss';

class LoginMenu extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            profile: {
                firstname: '',
                lastname: '',
            },
        };

        this.onProfileClick = this.onProfileClick.bind(this);
        this.onLogoutClick = this.onLogoutClick.bind(this);
    }

    componentDidMount() {
        ProfileService.getLoggedAccountProfile().then((profile) => {
            this.setState({ profile });
        });
    }

    onProfileClick() {
        AnalyticsService.gaTrigger(TAGS.LOGIN_WIDGET__ACCOUNT());

        ModalService.get(PROFILE).open();
    }

    onLogoutClick() {
        AnalyticsService.gaTrigger(TAGS.LOGIN_WIDGET__LOGOUT());
        AuthenticationService.logout();
    }

    render() {
        const name = `${this.state.profile.firstname} ${this.state.profile.lastname}`;

        return (
            <div className="LoginMenu login-container">
                <div className="dropdown-trigger">
                    <span className="login-name">
                        <MediaQuery minWidth={768}>
                            {LocaleService.t('LOGIN.LOGIN_BANNER.WELCOME_USER_NAME')}
                            {name}
                        </MediaQuery>
                        <MediaQuery maxWidth={767}>
                            <icon className="icon-login" />
                        </MediaQuery>
                    </span>

                    <div className="dropdown">
                        <div className="dropdown-selection">
                            <icon className="icon-keyboard_arrow_down" />
                        </div>
                        <div className="dropdown-content sr-topbar-login">
                            <ul>
                                <li>
                                    <a id="profile-link" href="#" onClick={this.onProfileClick} className="is-light">
                                        {LocaleService.t('LOGIN.LOGIN_BANNER.MY_ACCOUNT')}
                                    </a>
                                </li>
                                <li>
                                    <a id="logout-link" href="#" onClick={this.onLogoutClick} className="is-light">
                                        {LocaleService.t('LOGIN.LOGIN_BANNER.LOGOUT')}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <ProfileModal />
            </div>
        );
    }
}

LoginMenu.displayName = 'LoginMenu';

export default LoginMenu;



// WEBPACK FOOTER //
// ./src/components/LoginMenu/LoginMenu.jsx